import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";

import { Label } from "@lawline/ui/components/label";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@lawline/ui/components/select";

// Theme `value`s map to next-themes keys; labels come from the `themes` message
// group so the dropdown follows the active locale.
const THEME_VALUES = [
	{ value: "light", labelKey: "light" },
	{ value: "dark", labelKey: "dark" },
	{ value: "system", labelKey: "system" },
] as const;

export function AppearanceSection() {
	const t = useTranslations("settings.appearance");
	const { theme, setTheme } = useTheme();
	const [mounted, setMounted] = useState(false);

	// next-themes resolves the active theme only after mount. Gate on mount to
	// avoid a flash of the wrong selected value.
	useEffect(() => setMounted(true), []);

	return (
		<section className="flex flex-col gap-6">
			<div className="flex flex-col gap-2">
				<Label htmlFor="theme">{t("theme")}</Label>
				<Select value={mounted ? theme : undefined} onValueChange={setTheme}>
					<SelectTrigger id="theme" className="w-50">
						<SelectValue placeholder={t("themePlaceholder")} />
					</SelectTrigger>
					<SelectContent>
						{THEME_VALUES.map((item) => (
							<SelectItem key={item.value} value={item.value}>
								{t(`themes.${item.labelKey}`)}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>
		</section>
	);
}
